module.exports = __webpack_public_path__ + "img/340500Image.4e169c64.png";